import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AppDispatch } from '../../Store';
import { setDialogCreateNewPasswordVisible } from '../../Slice/DialogSlice';
import Footer from '../footer/Footer';
import { setLinkuid } from '../../Slice/AllParameter';

/**
 * @author noone
 */
export default function PasswordResetLink() {

    var url = window.location;
    const { uid } = useParams();
    const dispatch = useDispatch<AppDispatch>();
    //const linkuid = useSelector((state: RootState) => state.allParameteSlice.linkuid);
    
    useEffect(() => {
        dispatch(setLinkuid(uid!));
        dispatch(setDialogCreateNewPasswordVisible(true));
     }, []);

    return (
        <div className="container flexdiv">

            <h3>PasswordReset</h3>

            {uid}

            <Footer />
        </div>
    );

}